import { Compass, Building2, Landmark, Handshake, Network, Presentation } from "lucide-react";
import { useLanguage } from "@/App";
import { translations } from "@/i18n";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ICONS = [Compass, Building2, Landmark, Handshake, Network, Presentation];
const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];

const Services = () => {
  const { lang } = useLanguage();
  const t = translations[lang].services;

  return (
    <section id="services" data-testid="services-section" className="bg-[#060A1A] py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <div className="grid gap-8 md:grid-cols-12">
            <h2 className="font-display text-4xl font-black tracking-tighter text-white sm:text-5xl md:col-span-8">
              {t.title}
            </h2>
            <p className="self-end text-base font-light text-slate-300 md:col-span-4 md:text-lg">
              {t.sub}
            </p>
          </div>
        </Reveal>

        <div className="mt-20 grid gap-px border border-white/10 bg-white/10 md:grid-cols-12">
          {t.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={`${lang}-${i}`} delay={i * 0.06} className={SPANS[i]}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full bg-[#101836] p-10 transition-colors duration-500 hover:bg-[#0A1128] lg:p-12"
                >
                  <span className="absolute left-0 top-0 h-full w-0.5 scale-y-0 bg-[#D4AF37] transition-transform duration-500 group-hover:scale-y-100" />
                  <Icon
                    className="h-8 w-8 text-white/30 transition-colors duration-500 group-hover:text-[#D4AF37]"
                    strokeWidth={1.25}
                  />
                  <span className="absolute right-8 top-8 font-display text-sm font-semibold tracking-widest text-white/20">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-8 font-display text-xl font-semibold tracking-tight text-white md:text-2xl">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm font-light leading-relaxed text-slate-300 md:text-base">
                    {s.body}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
